export function unwindBy<T>(
  arr: T[],
  field: string,
  valueMapper?: (obj: any) => any
) {
  return arr.reduce(
    (r, o) =>
      r.concat(
        (o as any)[field].map((v: any) => ({
          ...o,
          [field]: valueMapper ? valueMapper(v) : v,
        }))
      ),
    [] as T[]
  );
}
